import join from 'join-classnames';
import styles from './sidebar.css';

const sidebarMenuContainerId = 'sidebarMenuContainer';
export const sidebarMenuContainerSelector = '#sidebarMenuContainer';

export const sidebarTemplate = ({
  desktopSidebarIsToggleable,
  closed
}) => `<div class="${join(
  styles.sidebarWrapper,
  desktopSidebarIsToggleable && styles.desktopSidebarIsToggleable,
  closed && styles.closed,
)}">
  <div class="${styles.overlay}"></div>
  <nav class="${styles.sidebar}" id="${sidebarMenuContainerId}"></nav>
</div>
`;
